
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31121",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31121",
  "emoji-mart": "static-3.10",
  "feedback-schema": "static-1.55718",
  "head-dlb": "static-1.5344",
  "hs-test-utils": "static-1.8585",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.12033",
  "I18n": "static-7.1727",
  "quartz": "static-1.7771",
  "quartz-config": "static-1.1549",
  "quartz-core": "static-1.6990",
  "react-dlb": "static-1.97",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.88",
  "reselect": "static-3.20",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1163",
  "enviro": "static-4.529",
  "feedback-shared-ui": "static-1.55705",
  "feedback-utils": "static-1.55709",
  "forms-embed-utils-lib": "static-1.5006",
  "forms-utils-lib": "static-1.13434",
  "foundations-assets": "static-1.5432",
  "foundations-components": "static-1.8856",
  "foundations-theming": "static-1.5046",
  "hub-http": "static-1.6745",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12340",
  "icons": "static-2.719",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4270",
  "raven": "static-3.6435",
  "react": "static-7.206",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17283",
  "react-select-plus": "static-1.121",
  "react-utils": "static-2.5721",
  "react-virtualized": "static-2.115",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.523",
  "tinymce-plugins": "static-1.58623",
  "transmute": "static-2.97",
  "ui-images": "static-2.1299",
  "UIComponents": "static-3.8979",
  "hs-promise-rejection-tracking": "static-1.6102",
  "PortalIdParser": "static-2.459",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4048",
  "quartz-webpack": "static-1.3995",
  "foundations-theming-specialty": "static-1.2762",
  "property-description-translator": "static-1.4358",
  "HeadJS": "static-2.839",
  "framer-motion": "static-1.87",
  "hs-test-utils-bend-plugin": "static-1.3696",
  "msw": "static-1.106",
  "msw-config": "static-1.46",
  "testing-library": "static-1.168",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.238",
  "moment-timezone": "static-5.99",
  "jasmine": "static-4.4848",
  "jasmine-runner": "static-1.7002",
  "opentelemetry-fe-types": "static-1.343",
  "dispatcher": "static-1.151",
  "general-store": "static-6.20",
  "hs-browser-apis": "static-1.18",
  "hub-http-janus": "static-1.923",
  "hubspotter-http": "static-1.5013",
  "mobile-manifest-mixins": "static-1.623",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.718",
  "quartz-auth": "static-1.1446",
  "quartz-head": "static-1.1436",
  "quartz-i18n": "static-1.1446",
  "quartz-routing": "static-1.1201",
  "quartz-test": "static-1.1446",
  "quartz-tracking": "static-1.1150",
  "trellis-components": "static-1.3294",
  "ui-fonts": "static-1.1295",
  "usage-tracker-container": "static-1.7879",
  "usage-tracker-core": "static-1.7739",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.430",
  "conversations-skeleton-state": "static-1.7657",
  "sanitize-text": "static-1.8700",
  "PatternValidationJS": "static-1.3419",
  "ReduxMessenger": "static-2.10915",
  "outpost": "static-1.4668",
  "rpc-client-utils": "static-1.5209",
  "reference-resolvers": "static-1.8729",
  "sanitize": "static-1.5011",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5125",
  "floating-ui": "static-1.71",
  "hs-story-utils": "static-1.9967",
  "react-aria": "static-1.80",
  "react-create-root-preference": "static-1.125",
  "tanstack-table": "static-1.69",
  "trellis-assets": "static-1.3275",
  "bend-plugin-foundations-theming": "static-1.3529",
  "foundations-theming-base": "static-1.4031",
  "stylex": "static-1.50",
  "hs-locale-management": "static-1.446",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.245",
  "web-vitals": "static-1.22",
  "ai-components-ui-library": "static-1.10139",
  "atom": "static-1.5616",
  "codemirror": "static-5.109",
  "content-assistance-lib": "static-1.8510",
  "ContentUtils": "static-1.69629",
  "data-token-picker": "static-1.17231",
  "file-manager-components": "static-1.24946",
  "FileManagerCore": "static-1.40445",
  "FileManagerLib": "static-1.40586",
  "frontend-preferences-client": "static-1.8466",
  "hub-http-contrib": "static-1.3573",
  "interframe": "static-3.5288",
  "layout-dnd-components": "static-1.13327",
  "layout-dnd-utils": "static-1.12302",
  "property-translator": "static-1.5918",
  "react-codemirror": "static-1.11184",
  "react-colorpicker": "static-2.10753",
  "reference-resolvers-lite": "static-1.8656",
  "rich-text-lib": "static-1.20655",
  "tinymce-data": "static-1.41594",
  "tinymce-themes": "static-1.57479",
  "ui-addon-emoji-picker": "static-1.10408",
  "ui-addon-sales-email": "static-1.5750",
  "ui-brand-identity-lib": "static-1.17109",
  "bender-build-tools": "static-1.3654",
  "opentelemetry-web": "static-1.26",
  "hub-http-shared-msw-handlers": "static-1.11012",
  "hubspotter-http-shared-msw-handlers": "static-1.11010",
  "usage-tracker-session-replay": "static-1.5575",
  "base-ui": "static-1.32",
  "react-day-picker": "static-1.19",
  "tanstack-virtual": "static-1.46",
  "trellis-theming": "static-1.1588",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.619",
  "chirp-fetch": "static-1.2443",
  "stylex-utils": "static-1.194",
  "chatspot-core": "static-1.24309",
  "copilot-toolkit": "static-1.12276",
  "customer-data-objects-ui-components": "static-1.13579",
  "data-fetching-client": "static-1.10178",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5298",
  "ui-addon-video-player": "static-1.9165",
  "ui-coaching-tips": "static-1.29646",
  "usage-tracker": "static-1.7889",
  "cms-field-types": "static-1.5356",
  "content-icons-ui": "static-1.2526",
  "integrations-lib": "static-1.17570",
  "customer-data-objects": "static-1.8258",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5132",
  "apollo-stack-hubspot": "static-3.102",
  "breeze-engine-lib": "static-1.2400",
  "graphql": "static-1.96",
  "immer": "static-1.107",
  "immerable": "static-1.4687",
  "poll-commands": "static-1.4017",
  "ui-addon-iframeable": "static-1.9622",
  "video-components-external": "static-1.12562",
  "video-data-lib": "static-1.36220",
  "audio-components": "static-1.6659",
  "breeze-artifacts-sdk": "static-1.1229",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30156",
  "FileManagerImages": "static-1.38097",
  "foundations-components-legacy": "static-1.1881",
  "html-to-image": "static-1.70",
  "redux-toolkit": "static-1.85",
  "salesImages": "static-1.801",
  "ui-universal-auth": "static-1.9871",
  "urlinator": "static-1.5060",
  "video-components": "static-1.14564",
  "video-embed": "static-1.37054",
  "ts-schema": "static-1.4437",
  "ContentData": "static-1.69704",
  "layout-data-lib": "static-1.10627",
  "react-dnd-compat": "static-1.5153",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2094",
  "external-options-client-types": "static-1.4478",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6133",
  "hs-resources": "static-1.739",
  "inbound-db-properties-service-client": "static-1.4193",
  "NamespacedHubStyle": "static-2.9411",
  "growth-onboarding-confetti": "static-1.3600",
  "SharedI18nStrings": "static-1.191",
  "ui-addon-i18n": "static-1.11691",
  "amplitude-session-replay-browser": "static-1.80",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5966",
  "magpie-types": "static-1.5426",
  "simple-logging-lib": "static-1.3590",
  "avatar-components": "static-1.3031",
  "customer-data-ui-utilities": "static-1.10376",
  "growth-onboarding-feedback-components": "static-1.7128",
  "flux-actions": "static-1.384",
  "hubspot-apollo-client": "static-1.5419",
  "integrations-error-boundary-lib": "static-1.14985",
  "integrations-tracking-lib": "static-1.6171",
  "laboratory-lib": "static-3.7692",
  "native-integrations-shared-strings": "static-1.8301",
  "redux-observable": "static-1.82",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10830",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1378",
  "breeze-engine-core": "static-1.1678",
  "highlight.js": "static-1.93",
  "pulse": "static-1.1214",
  "navigation-messaging": "static-1.8665",
  "content-media-composition-data-lib": "static-1.13702",
  "content-media-compositions": "static-2.17709",
  "idb-keyval": "static-1.59",
  "media-bridge-lib": "static-1.19737",
  "nudge-client-utils": "static-1.3519",
  "custom-vendor-connection-lib": "static-1.435",
  "unified-auth-core-lib": "static-1.1667",
  "social-insights-client-types": "static-1.23053",
  "advanced-menus-core": "static-1.15917",
  "advanced-menus-lib": "static-1.12644",
  "ExportDialog": "static-6.10915",
  "ui-memberships-settings-lib": "static-1.35338",
  "conditional-properties-service-client": "static-1.4154",
  "crm-pipelines-api-client-types": "static-1.4487",
  "event-emitter": "static-1.1500",
  "fdsr-migration-layer": "static-1.557",
  "framework-builder-read-service-client": "static-1.4374",
  "inbound-db-meta-service-client": "static-1.3813",
  "multi-currency-client-types": "static-1.4052",
  "foundations-components-test-utils": "static-1.6339",
  "reactive-lib": "static-1.1265",
  "trellis-migration-context": "static-1.121",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.878",
  "universal-page-editor-lib": "static-1.3563",
  "bend-plugin-pulse": "static-1.717",
  "fast-json-patch": "static-1.79",
  "nav-meta": "static-1.30975",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3276",
  "nudge-renderer-utils": "static-1.3595",
  "onboarding-tours": "static-1.17490",
  "whisper-core-api": "static-1.7748",
  "fsm": "static-1.4304",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15916",
  "simple-menus-lib": "static-1.17433",
  "settings-ui-lib": "static-1.13076",
  "persist-promise": "static-1.4251",
  "crm-record-cards-client": "static-1.242",
  "crm-record-cards-service-types": "static-1.3897",
  "framework-data-schema-resolvers": "static-1.7432",
  "location-customization-utils-lib": "static-1.10565",
  "getting-started-shared-tasks": "static-1.19671",
  "growth-data-modal": "static-1.6225",
  "growth-onboarding-next-action-utils": "static-1.3108",
  "navigation-components": "static-1.19338",
  "nest": "static-1.782",
  "onboarding-tours-client": "static-1.5705",
  "onboarding-tours-utils": "static-1.1557",
  "ui-shepherd-tracker": "static-1.8211",
  "user-context": "static-1.5598",
  "react-flip-move": "static-1.86",
  "framework-data-schema-quick-fetch": "static-1.7337",
  "onboarding-data-sync-lib": "static-1.2929",
  "growth-onboarding-next-action-components": "static-1.3136",
  "user-context-client": "static-1.5051",
  "getting-started-shared-tasks-store": "static-1.18789",
  "InboxConnectUtils": "static-4.15965",
  "meetings-connect-utils-lib": "static-1.8162",
  "onboarding-scopes": "static-1.6995"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31121",
  "emoji-mart": "/emoji-mart/static-3.10",
  "feedback-schema": "/feedback-schema/static-1.55718",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-test-utils": "/hs-test-utils/static-1.8585",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.12033",
  "I18n": "/I18n/static-7.1727",
  "quartz": "/quartz/static-1.7771",
  "quartz-config": "/quartz-config/static-1.1549",
  "quartz-core": "/quartz-core/static-1.6990",
  "react-dlb": "/react-dlb/static-1.97",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.88",
  "reselect": "/reselect/static-3.20",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1163",
  "enviro": "/enviro/static-4.529",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55705",
  "feedback-utils": "/feedback-utils/static-1.55709",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.5006",
  "forms-utils-lib": "/forms-utils-lib/static-1.13434",
  "foundations-assets": "/foundations-assets/static-1.5432",
  "foundations-components": "/foundations-components/static-1.8856",
  "foundations-theming": "/foundations-theming/static-1.5046",
  "hub-http": "/hub-http/static-1.6745",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12340",
  "icons": "/icons/static-2.719",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4270",
  "raven": "/raven/static-3.6435",
  "react": "/react/static-7.206",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17283",
  "react-select-plus": "/react-select-plus/static-1.121",
  "react-utils": "/react-utils/static-2.5721",
  "react-virtualized": "/react-virtualized/static-2.115",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.523",
  "tinymce-plugins": "/tinymce-plugins/static-1.58623",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1299",
  "UIComponents": "/UIComponents/static-3.8979",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4048",
  "quartz-webpack": "/quartz-webpack/static-1.3995",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2762",
  "property-description-translator": "/property-description-translator/static-1.4358",
  "HeadJS": "/HeadJS/static-2.839",
  "framer-motion": "/framer-motion/static-1.87",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3696",
  "msw": "/msw/static-1.106",
  "msw-config": "/msw-config/static-1.46",
  "testing-library": "/testing-library/static-1.168",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.238",
  "moment-timezone": "/moment-timezone/static-5.99",
  "jasmine": "/jasmine/static-4.4848",
  "jasmine-runner": "/jasmine-runner/static-1.7002",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.343",
  "dispatcher": "/dispatcher/static-1.151",
  "general-store": "/general-store/static-6.20",
  "hs-browser-apis": "/hs-browser-apis/static-1.18",
  "hub-http-janus": "/hub-http-janus/static-1.923",
  "hubspotter-http": "/hubspotter-http/static-1.5013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.623",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.718",
  "quartz-auth": "/quartz-auth/static-1.1446",
  "quartz-head": "/quartz-head/static-1.1436",
  "quartz-i18n": "/quartz-i18n/static-1.1446",
  "quartz-routing": "/quartz-routing/static-1.1201",
  "quartz-test": "/quartz-test/static-1.1446",
  "quartz-tracking": "/quartz-tracking/static-1.1150",
  "trellis-components": "/trellis-components/static-1.3294",
  "ui-fonts": "/ui-fonts/static-1.1295",
  "usage-tracker-container": "/usage-tracker-container/static-1.7879",
  "usage-tracker-core": "/usage-tracker-core/static-1.7739",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.430",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7657",
  "sanitize-text": "/sanitize-text/static-1.8700",
  "PatternValidationJS": "/PatternValidationJS/static-1.3419",
  "ReduxMessenger": "/ReduxMessenger/static-2.10915",
  "outpost": "/outpost/static-1.4668",
  "rpc-client-utils": "/rpc-client-utils/static-1.5209",
  "reference-resolvers": "/reference-resolvers/static-1.8729",
  "sanitize": "/sanitize/static-1.5011",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5125",
  "floating-ui": "/floating-ui/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9967",
  "react-aria": "/react-aria/static-1.80",
  "react-create-root-preference": "/react-create-root-preference/static-1.125",
  "tanstack-table": "/tanstack-table/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.3275",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3529",
  "foundations-theming-base": "/foundations-theming-base/static-1.4031",
  "stylex": "/stylex/static-1.50",
  "hs-locale-management": "/hs-locale-management/static-1.446",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.245",
  "web-vitals": "/web-vitals/static-1.22",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10139",
  "atom": "/atom/static-1.5616",
  "codemirror": "/codemirror/static-5.109",
  "content-assistance-lib": "/content-assistance-lib/static-1.8510",
  "ContentUtils": "/ContentUtils/static-1.69629",
  "data-token-picker": "/data-token-picker/static-1.17231",
  "file-manager-components": "/file-manager-components/static-1.24946",
  "FileManagerCore": "/FileManagerCore/static-1.40445",
  "FileManagerLib": "/FileManagerLib/static-1.40586",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8466",
  "hub-http-contrib": "/hub-http-contrib/static-1.3573",
  "interframe": "/interframe/static-3.5288",
  "layout-dnd-components": "/layout-dnd-components/static-1.13327",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12302",
  "property-translator": "/property-translator/static-1.5918",
  "react-codemirror": "/react-codemirror/static-1.11184",
  "react-colorpicker": "/react-colorpicker/static-2.10753",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8656",
  "rich-text-lib": "/rich-text-lib/static-1.20655",
  "tinymce-data": "/tinymce-data/static-1.41594",
  "tinymce-themes": "/tinymce-themes/static-1.57479",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10408",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5750",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17109",
  "bender-build-tools": "/bender-build-tools/static-1.3654",
  "opentelemetry-web": "/opentelemetry-web/static-1.26",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11012",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11010",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5575",
  "base-ui": "/base-ui/static-1.32",
  "react-day-picker": "/react-day-picker/static-1.19",
  "tanstack-virtual": "/tanstack-virtual/static-1.46",
  "trellis-theming": "/trellis-theming/static-1.1588",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.619",
  "chirp-fetch": "/chirp-fetch/static-1.2443",
  "stylex-utils": "/stylex-utils/static-1.194",
  "chatspot-core": "/chatspot-core/static-1.24309",
  "copilot-toolkit": "/copilot-toolkit/static-1.12276",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13579",
  "data-fetching-client": "/data-fetching-client/static-1.10178",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5298",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9165",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29646",
  "usage-tracker": "/usage-tracker/static-1.7889",
  "cms-field-types": "/cms-field-types/static-1.5356",
  "content-icons-ui": "/content-icons-ui/static-1.2526",
  "integrations-lib": "/integrations-lib/static-1.17570",
  "customer-data-objects": "/customer-data-objects/static-1.8258",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5132",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.102",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2400",
  "graphql": "/graphql/static-1.96",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4687",
  "poll-commands": "/poll-commands/static-1.4017",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9622",
  "video-components-external": "/video-components-external/static-1.12562",
  "video-data-lib": "/video-data-lib/static-1.36220",
  "audio-components": "/audio-components/static-1.6659",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1229",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30156",
  "FileManagerImages": "/FileManagerImages/static-1.38097",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1881",
  "html-to-image": "/html-to-image/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.85",
  "salesImages": "/salesImages/static-1.801",
  "ui-universal-auth": "/ui-universal-auth/static-1.9871",
  "urlinator": "/urlinator/static-1.5060",
  "video-components": "/video-components/static-1.14564",
  "video-embed": "/video-embed/static-1.37054",
  "ts-schema": "/ts-schema/static-1.4437",
  "ContentData": "/ContentData/static-1.69704",
  "layout-data-lib": "/layout-data-lib/static-1.10627",
  "react-dnd-compat": "/react-dnd-compat/static-1.5153",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2094",
  "external-options-client-types": "/external-options-client-types/static-1.4478",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6133",
  "hs-resources": "/hs-resources/static-1.739",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4193",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9411",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3600",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.191",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11691",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5966",
  "magpie-types": "/magpie-types/static-1.5426",
  "simple-logging-lib": "/simple-logging-lib/static-1.3590",
  "avatar-components": "/avatar-components/static-1.3031",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10376",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7128",
  "flux-actions": "/flux-actions/static-1.384",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5419",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14985",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6171",
  "laboratory-lib": "/laboratory-lib/static-3.7692",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8301",
  "redux-observable": "/redux-observable/static-1.82",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10830",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1378",
  "breeze-engine-core": "/breeze-engine-core/static-1.1678",
  "highlight.js": "/highlight.js/static-1.93",
  "pulse": "/pulse/static-1.1214",
  "navigation-messaging": "/navigation-messaging/static-1.8665",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13702",
  "content-media-compositions": "/content-media-compositions/static-2.17709",
  "idb-keyval": "/idb-keyval/static-1.59",
  "media-bridge-lib": "/media-bridge-lib/static-1.19737",
  "nudge-client-utils": "/nudge-client-utils/static-1.3519",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.435",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1667",
  "social-insights-client-types": "/social-insights-client-types/static-1.23053",
  "advanced-menus-core": "/advanced-menus-core/static-1.15917",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12644",
  "ExportDialog": "/ExportDialog/static-6.10915",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35338",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4154",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4487",
  "event-emitter": "/event-emitter/static-1.1500",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.557",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4374",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3813",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4052",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6339",
  "reactive-lib": "/reactive-lib/static-1.1265",
  "trellis-migration-context": "/trellis-migration-context/static-1.121",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.878",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3563",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.717",
  "fast-json-patch": "/fast-json-patch/static-1.79",
  "nav-meta": "/nav-meta/static-1.30975",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3276",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3595",
  "onboarding-tours": "/onboarding-tours/static-1.17490",
  "whisper-core-api": "/whisper-core-api/static-1.7748",
  "fsm": "/fsm/static-1.4304",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15916",
  "simple-menus-lib": "/simple-menus-lib/static-1.17433",
  "settings-ui-lib": "/settings-ui-lib/static-1.13076",
  "persist-promise": "/persist-promise/static-1.4251",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.242",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3897",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7432",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10565",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19671",
  "growth-data-modal": "/growth-data-modal/static-1.6225",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3108",
  "navigation-components": "/navigation-components/static-1.19338",
  "nest": "/nest/static-1.782",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5705",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1557",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8211",
  "user-context": "/user-context/static-1.5598",
  "react-flip-move": "/react-flip-move/static-1.86",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7337",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2929",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3136",
  "user-context-client": "/user-context-client/static-1.5051",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18789",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15965",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8162",
  "onboarding-scopes": "/onboarding-scopes/static-1.6995"
}
};
